import { modalController } from '@ionic/core';
import { SubmittalDoc } from 'common';

/** Saved doc, `false` if the unsaved draft was discarded, `null` if the modal was closed. */
export type SubmittalEditResult = SubmittalDoc | false | null;

export class SubmittalEditModalController {
  static async present(projectId: string, submittal: SubmittalDoc, sidepanel: boolean = false, testid: string = 'submittal-edit-modal'): Promise<SubmittalEditResult> {
    const { result } = await this.presentModal(projectId, submittal, sidepanel, testid);
    return result;
  }

  /** Create and present the edit modal, returning the modal element so callers can dismiss it later. */
  static async presentModal(
    projectId: string,
    submittal: SubmittalDoc,
    sidepanel: boolean = false,
    testid: string = 'submittal-edit-modal',
  ): Promise<{ modal: HTMLIonModalElement; result: Promise<SubmittalEditResult> }> {
    const modal = await modalController.create({
      component: 'submittal-edit-modal',
      componentProps: { projectId, original: submittal, testid },
      backdropDismiss: false,
      cssClass: sidepanel ? 'modal-sidepanel' : 'modal-height-auto',
    });

    const result = new Promise<SubmittalEditResult>(async resolve => {
      let settled = false;
      const finish = (value: SubmittalEditResult) => {
        if (settled) return;
        settled = true;
        resolve(value);
      };

      modal.addEventListener('saved', (e: CustomEvent<SubmittalDoc>) => {
        modal.dismiss();
        finish(e.detail);
      });
      modal.addEventListener('discarded', () => {
        modal.dismiss();
        finish(false);
      });
      modal.addEventListener('dismiss', () => {
        modal.dismiss();
        finish(null);
      });
      // Covers programmatic dismiss (e.g. replacing or clearing from the viewer)
      modal.addEventListener('ionModalDidDismiss', () => finish(null));

      await modal.present();
    });

    return { modal, result };
  }
}
